import React from "react";
import "./index.scss";
import Dialog from "../../../../shared/dialog";
import MyButton from "../../../../shared/buttons/primary";

const DeleteDialog = (props) => {
  const { onClose, data, isShow } = props;
  const [isBtnDisabled, setIsBtnDisabled] = React.useState(false);

  const deleteMenu = () => {
    setIsBtnDisabled(true);
    window
      .axios({
        url: `/seat/${data.id}/`,
        method: "delete",
      })
      .then(() => {
        onClose(data);
      });
  };

  const onCloseRequest = (data) => {
    onClose(data);
  };

  return (
    <Dialog
      id="table-delete-dialog"
      className={"table-delete-dialog"}
      title={"削除"}
      isShow={isShow}
      onCloseRequest={onCloseRequest}
      closeOnOverlayClick={true}
    >
      <div>
        <h2 className="text-center">この選択肢を削除してもよろしいですか？</h2>
        <div className="booking-form__btns">
          <MyButton
            className="me-1"
            myVariant="cancel"
            disabled={isBtnDisabled}
            onClick={onCloseRequest}
          >
            キャンセル
          </MyButton>
          <MyButton
            myVariant="delete"
            isLoading={isBtnDisabled}
            onClick={deleteMenu}
          >
            削除する
          </MyButton>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
